export default __webpack_public_path__ + "static/media/broadcast.2e9e7de6.png";